__turbopack_context__.v({
  "avatar": "TestimonialCard-module__iQjcKG__avatar",
  "card": "TestimonialCard-module__iQjcKG__card",
  "metaRow": "TestimonialCard-module__iQjcKG__metaRow",
  "metaText": "TestimonialCard-module__iQjcKG__metaText",
  "name": "TestimonialCard-module__iQjcKG__name",
  "quote": "TestimonialCard-module__iQjcKG__quote",
  "title": "TestimonialCard-module__iQjcKG__title",
});
